import { useEffect, useRef, useState } from "react";
import { formatInvoiceAmount } from "../../utils/dashboardRevenue";

function AnimatedCurrency({ value, duration = 450 }) {
  const [displayValue, setDisplayValue] = useState(value);
  const [animating, setAnimating] = useState(false);
  const frameRef = useRef(null);
  const startRef = useRef(null);
  const fromRef = useRef(value);

  useEffect(() => {
    if (frameRef.current) {
      cancelAnimationFrame(frameRef.current);
    }

    const from = fromRef.current;
    const to = Number(value) || 0;
    if (from === to) {
      setDisplayValue(to);
      return undefined;
    }

    setAnimating(true);
    startRef.current = null;

    const step = (timestamp) => {
      if (!startRef.current) {
        startRef.current = timestamp;
      }
      const progress = Math.min((timestamp - startRef.current) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const next = from + (to - from) * eased;
      setDisplayValue(next);
      if (progress < 1) {
        frameRef.current = requestAnimationFrame(step);
      } else {
        fromRef.current = to;
        setAnimating(false);
      }
    };

    frameRef.current = requestAnimationFrame(step);
    return () => {
      if (frameRef.current) {
        cancelAnimationFrame(frameRef.current);
      }
    };
  }, [value, duration]);

  return (
    <span
      className={`inline-block tabular-nums transition-opacity duration-200 ${
        animating ? "opacity-90" : "opacity-100"
      }`}
    >
      {formatInvoiceAmount(displayValue)}
    </span>
  );
}

export { AnimatedCurrency };
